import React from 'react'
import { BottomNav } from './styled'

import asbLogo from '../../assets/asbLogo.png'
import lesaLogo from '../../assets/lesaLogo.png'
import hashtag from '../../assets/hashtag.png'
import sponsorDesktop from '../../assets/sponsorDesktop.jpg'
import sponsorMobile from '../../assets/sponsorMobile.png'

const Footer = () => {
  return (
    <BottomNav>
      <div className="sponsors">
        <picture>
          <source srcSet={sponsorMobile} media="(max-width: 768px)" />
          <source srcSet={sponsorDesktop} />
          <img src={sponsorDesktop} alt="Background" />
        </picture>
      </div>
      <div className="row g-0 h-100">
        <div className="col-md-6 left flex-grow-1">
          <img src={asbLogo} className="logo" alt="logo" />
          <div className="fw-bold">HYBRID CONFERENCE | MAR 15 - 16</div>
        </div>
        <div className="col-md-6 right flex-grow-1">
          <img src={hashtag} className="logo" alt="logo" />
          <img src={lesaLogo} className="logo" alt="logo" />
          <div>
            <a
              href="https://lesa2023.asb.edu.my/contact/"
              target="_blank"
              rel="noreferrer"
            >
              Contact Us
            </a>
            <a
              href="https://asb.edu.my/policy/"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </BottomNav>
  )
}

export default Footer
